import { render, staticRenderFns } from "./helpProblem.vue?vue&type=template&id=074bad18&scoped=true"
import script from "./helpProblem.vue?vue&type=script&lang=js"
export * from "./helpProblem.vue?vue&type=script&lang=js"
import style0 from "./../style.scss?vue&type=style&index=0&id=074bad18&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074bad18",
  null
  
)

export default component.exports